import React from 'react'
import { useTranslation } from 'react-i18next'
import TrikonasanaImg from '../../../../../assets/images/yoga/Trikonasana.png'
import SubCard from '../../../../../comon/SubCard'
import Header from '../../subcategory/Header'

const BloodPresure = () => {
    const {t} = useTranslation();
    return (
        <>
        <Header headtitle={t("yoga.bloodpressure")} />
        <SubCard fitImg={TrikonasanaImg} title={t("Trikonasana.title")} context={false} workoutLink='/trikonasana' />
        </>
      )
    }

export default BloodPresure
